var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 6.705L3.71504 0L2.65379 1.06125L4.43879 2.84625L0.580039 6.705C0.141289 7.14375 0.141289 7.85625 0.580039 8.295L4.70504 12.42C4.92254 12.6412 5.21129 12.75 5.50004 12.75C5.78879 12.75 6.07754 12.6412 6.29504 12.42L10.42 8.295C10.8588 7.85625 10.8588 7.14375 10.42 6.705ZM1.90379 7.5L5.50004 3.9075L9.09629 7.5H1.90379ZM12.25 8.625C12.25 8.625 10.75 10.2487 10.75 11.25C10.75 12.0787 11.4213 12.75 12.25 12.75C13.0788 12.75 13.75 12.0787 13.75 11.25C13.75 10.2487 12.25 8.625 12.25 8.625Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/Color.dbba8ed4.svg";
export { ForwardRef as ReactComponent };